import { templateMemo } from "./memo";
import { templateOficio } from "./oficio";
import { templateResolucion } from "./resolucion";

export const listTemplates=[
    templateMemo,
    templateOficio,
    templateResolucion,
]